import { WorkspacesQuery } from 'front-end/src/pages/home-page/components/your-workspaces/YourWorkspaces.codegen'

type WorkspaceCategory = {
  id: number
  name: string
  workspaces: WorkspacesQuery['workspaces']
}

type WorkspaceCategoryTree = {
  categories: WorkspaceCategory[]
  workspacesWithoutCategories: WorkspacesQuery['workspaces']
}

export const buildWorkspaceCategoryTree = (
  workspaces: WorkspacesQuery['workspaces']
) => {
  let categories: WorkspaceCategoryTree['categories'] = []
  ;(workspaces || []).forEach((workspace) => {
    ;(workspace.tags || []).forEach((frozenTag) => {
      let category = categories.find((c) => c.id === frozenTag.id)
      if (!category) {
        category = { ...frozenTag, workspaces: [] } // Make tag extensible by copying
        categories.push(category)
      }

      category.workspaces.push(workspace)
    })
  })

  return {
    categories: categories.sort((a, b) => (a.name > b.name ? 1 : -1)),
    workspacesWithoutCategories: workspaces.filter(
      (workspace) => workspace.tags.length === 0
    )
  } as WorkspaceCategoryTree
}
